import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "d-flex align-items-center position-relative me-1" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-warning",
  "data-bs-toggle": "modal",
  "data-bs-target": "#card-update"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" update ")
const _hoisted_7 = {
  class: "modal fade",
  ref: "uploadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "card-update"
}
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_9 = { class: "modal-content rounded" }
const _hoisted_10 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_11 = { class: "svg-icon svg-icon-1" }
const _hoisted_12 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Update kartu"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5 mb-4" }, " Apakah yakin akan merubah desain kartu ini ? "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10 m-auto alert alert-danger" }, " Jika perubahan desain dilakukkan akan dikenakan biaya sebesar Rp. 100.000 ")
], -1)
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["data-kt-indicator", "disabled"]
const _hoisted_16 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Ok ")
const _hoisted_18 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_19 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_response_upload_siswa"
}
const _hoisted_24 = { class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" }
const _hoisted_25 = { class: "modal-content rounded" }
const _hoisted_26 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_27 = { class: "svg-icon svg-icon-1" }
const _hoisted_28 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_29 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_30 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_31 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_32 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_33 = { class: "d-flex flex-column fv-row" }
const _hoisted_34 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_35 = {
  key: 0,
  class: "table-responsive mt-4"
}
const _hoisted_36 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor Identitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note")
  ])
], -1)
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.batalUpload()))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_form, {
              id: "card-update",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.targetData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger me-3",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.batalUpload()))
                  }, " Batal "),
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-lg btn-primary",
                    type: "submit",
                    disabled: _ctx.items.disableButton
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("span", _hoisted_18, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_22))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_15)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.kembaliSiswa()))
            }, [
              _createElementVNode("span", _hoisted_27, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createElementVNode("span", null, "Total Siswa = " + _toDisplayString(_ctx.items.total), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, [
                _createElementVNode("span", null, "Data Siswa Valid = " + _toDisplayString(_ctx.items.valid), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, [
                _createElementVNode("span", null, "Data Siswa Tidak Valid = " + _toDisplayString(_ctx.items.unValid), 1)
              ])
            ]),
            (_ctx.items.unValidData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("table", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.unValidData, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_38, _toDisplayString(item.identityNumber), 1),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(item.name), 1),
                          _createElementVNode("td", _hoisted_40, _toDisplayString(item.note), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger me-3",
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.kembaliSiswa()))
            }, " Kembali ")
          ])
        ])
      ])
    ])
  ], 64))
}